import React from 'react';
import { Box, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { capitalize } from 'lodash';
import { colors } from '../../theme';
import { typeformMarkdownFormatter } from '../../utilities';

interface PetParent {
  firstName: string;
  lastName: string;
}

interface Animal {
  name: string;
  animalType: string; // Change from 'Dog' | 'Cat' to string
  careType?: string; // Add optional careType
}

interface Answer {
  id: string;
  question: string;
  text: string;
}

interface SurveyResponse {
  id: string;
  petParent: PetParent;
  submittedAt: string;
  title: string;
  answers: Answer[];
}

interface SurveyResponseCardProps {
  response: SurveyResponse;
  onClick?: () => void;
}

function SurveyResponseCard({ response, onClick }: SurveyResponseCardProps) {
  return (
    <Box
      sx={{
        background: colors.grey[50],
        padding: 2,
        borderRadius: 1,
        height: '100%',
        cursor: onClick ? 'pointer' : 'default',
        '&:hover': onClick ? {
          background: colors.grey[100],
        } : {},
      }}
      onClick={onClick}
    >
      <Typography variant="subtitle2" sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
        <Box>
          <Box>
            <Box sx={{ textTransform: 'capitalize', display: 'inline-block', color: colors.primary.main }}>
              {`${capitalize(response.petParent.firstName)} ${capitalize(response.petParent.lastName)} - `}
              &nbsp;
            </Box>
            <span dangerouslySetInnerHTML={{ __html: response.title }} />
          </Box>
        </Box>
        <Box sx={{ color: colors.secondary.text, ml: 1 }}>
          {dayjs(response.submittedAt).format('M/DD/YYYY')}
        </Box>
      </Typography>
      {
        response.answers.map((answer, idx) => (
          <Box
            sx={{ mb: idx < response.answers.length - 1 ? 1.5 : 0 }}
            key={`${answer.question}_${idx}_${response.id}`}
          >
            <Typography variant="caption" sx={{ color: colors.secondary.text }}>{typeformMarkdownFormatter(answer.question)}</Typography>
            <Typography variant="body2">{answer.text || '-'}</Typography>
          </Box>
        ))
      }
    </Box>
  );
}

export default SurveyResponseCard;
